<app-button 
  *ngIf="mobileDetector.isMobile | async; else desktopMenu" 
  icon="more"
  size="small"
  (onCLick)="openModal()"
></app-button>

<app-bottom-drawer 
  *ngIf="mobileDetector.isMobile | async" 
  [showDrawer]="showModal"
  [hideHeader]="true"
>
  <div class="menu_buttons_wrapper" (click)="onContentClick()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</app-bottom-drawer>

<ng-template #desktopMenu>
  <app-popup-menu>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </app-popup-menu>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>




